import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';
import MainNavbar from './components/Navbar';
import About from './components/About';
import Testimonial from './components/Testimonial';

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <MainNavbar/>
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/testimonials" element={<Testimonial />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;